import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Image from '../../content/images/NASE_logo.png'
import { width } from '@material-ui/system'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'rigth',
    color: theme.palette.text.secondary,
  }
}));

export const Voucher = (props) => {
    const classes = useStyles()

    React.useEffect(() => {
        console.log(props)
    }, [])

    return (
        <div className={classes.root} id="divToPrint">
          <Grid container spacing={3}>
            <Grid item xs={12}>
                <div style={{display:'flex'}}>
                    <img src={Image} style={{alignItems:'left', width: '40%'}}/>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" align="center" style={{fontWeight:'bold'}}>
                    COMPROBANTE DE PAGO
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Paper className={classes.paper}>
                    <Typography variant="h7" align="center" style={{fontWeight:'bold'}}>
                        DATOS DEL CLIENTE
                    </Typography>
                </Paper>
            </Grid>
            <Grid container spacing={0}>
                <Grid item xs={6}>
                    <p>TIPO DOCUMENTO</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.reference2}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>NO. DOCUMENTO</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.reference3}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>IP</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.reference1 != null ? props.reference1 : "NO REGISTRADO"}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>CORREO ELECTRÓNICO</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.email}</p>
                </Grid>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Typography variant="h7" style={{fontWeight:'bold'}}>
                    DATOS DEL PAGO
                </Typography>
              </Paper>
            </Grid>
            <Grid container spacing={0}>
                <Grid item xs={6}>
                    <p>PAGO A</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.bankName != null ? props.bankName : "NO REGISTRADO"}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>CUS</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.trazabilityCode != null ? props.trazabilityCode : "NO REGISTRADO"}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>NO. REFERENCIA</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.paymentID}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>TOTAL PAGADO</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{props.amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
                </Grid>
                <Grid item xs={6}>
                    <p>ESTADO</p>
                </Grid>
                <Grid item xs={6}>
                <p>{props.state == 1 ? "PENDIENTE" :
                    props.state == 2 ? "RECHAZADO" :
                    props.state == 4 ? "APROBADO" :  "RECHAZADO" }</p>
                </Grid>
                <Grid item xs={6}>
                    <p>FECHA</p>
                </Grid>
                <Grid item xs={6}>
                    <p>{new Date(props.solicitedDate).toLocaleString()}</p>
                </Grid>
            </Grid>
          </Grid>
        </div>
    )
}